import React from 'react';
import { VideoTrailer } from './VideoPlayerStyles';

const VideoPlayer = ({ video, setBool }) => {
  const handleClick = () => {
    setBool(false);
  };
  return (
    <VideoTrailer onClick={handleClick}>
      <div className='aspect-wrap'>
        <iframe
          className='trailer'
          width='550'
          height='315'
          src={`https://www.youtube.com/embed/${video}`}
          title='YouTube video player'
          frameBorder='0'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen
        ></iframe>
      </div>
    </VideoTrailer>
  );
};

export default VideoPlayer;
